import { SET_ITEMS } from '../mutation-types'
import axios from 'axios'
import findIndex from 'lodash/findIndex'

const DELETE_ITEM = 'DELETE_ITEM'

export default {
    namespaced: true,

    state: {
        data: [],
        meta: null
    },

    getters: {
        //
    },

    mutations: {
        [SET_ITEMS](state, { data, meta }) {
            state.data = data
            state.meta = meta
        },

        [DELETE_ITEM](state, modemId) {
            const index = findIndex(state.data, modem => modem.id === modemId)
            state.data.splice(index, 1)
        }
    },

    actions: {
        async fetchAll({ commit }, params) {
            //

            try {
                let response = await axios.get('api/modems', { params })
                commit(SET_ITEMS, response.data)
            } catch (error) {
                return false
            }

            return true
        },

        async delete({ commit }, modemId) {
            try {
                await axios.delete(`api/modems/${modemId}`)

                commit(DELETE_ITEM, modemId)
            } catch (error) {
                return false
            }

            return true
        }
    }
}
